import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { apiState } from '../../Api';
import { Button, Card, CardContent, CardTitle, withStateCard } from '../../Components'
import { PreProjetoStore, PREPROJETO_STORE } from '../../Store';
import { format } from 'date-fns';
import styled from 'styled-components';

interface IProps extends RouteComponentProps {
  [PREPROJETO_STORE]: PreProjetoStore
}

interface IState {
  apiState: number
}

const StyledCardContent = styled(CardContent) <any>`
  padding-top: 0px;
  padding-bottom: 10px;
  line-height: 28px;
`

const StyledList = styled.ul`
  list-style: none;
  line-height: 30px;
`

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const ContainerWithState = withStateCard(Container);

@inject(PREPROJETO_STORE)
@observer
export default class InstrucoesPreProjetoPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      apiState: apiState.loading
    }
  }

  getParametros = async () => {
    const store = this.props[PREPROJETO_STORE]
    await store.getParamsPreProjeto()
  }

  componentDidMount() {
    this.getParametros()
  }

  render() {
    const { history } = { ...this.props }
    const store = this.props[PREPROJETO_STORE]
    const { preProjetoState, parametros } = store

    return (
      <ContainerWithState
        state={preProjetoState}
      >
        <Card>
          <CardTitle>Instruções Pré-Projeto {new Date().getFullYear()}</CardTitle>
          <CardTitle>
            Período de Inscrição: {parametros &&
              format(parametros.dataDeInicioInscricoes, 'DD/MM/YYYY')} a {parametros &&
                format(parametros.dataDeFimInscricoes, 'DD/MM/YYYY')}
          </CardTitle>
          <StyledCardContent>
            <StyledList>
              <li>- Preencha todos os campos abaixo para efetivar com sucesso sua inscrição.</li>
              <li>- Escolha 3 docentes diferentes, observando a ordem de sua preferência.</li>
              <li>- O pré-projeto poderá ser editado até o final do período de inscrição.</li>         
            </StyledList>
          </StyledCardContent>
          <StyledCardContent>
            {parametros && parametros.observacao}
          </StyledCardContent>
        </Card>
        <Button onClick={() => window.open('https://www.direitosbc.br/graduacao/tcc/', '_blank')} color="secondaryLightColor">
                Clique aqui para mais informações sobre o TCC
        </Button>
        <Button onClick={() => history.push('/aluno/inscricao')}>
          Ir para Inscrição do Pré-Projeto
        </Button>
      </ContainerWithState>

    )
  }
}